import React, { FunctionComponent } from 'react';

import { SvgProps, propsHelperRem } from '@/shared/lib/propsHelper';

const EyeOn: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(2.4, 2.5, props)}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.25 12.5s-5.037 7-11.25 7-11.25-7-11.25-7 5.037-7 11.25-7 11.25 7 11.25 7Zm-7.75 0a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
        />
    </svg>
);
export default EyeOn;
